import axios from '../helpers/axios'
import { logError } from '../services';
import { IDropdownResponse } from '../models';

export const getEmailTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/test-emails`);
    return data;
  } catch (error) {
    logError(error, 'getEmailTypes failed');
    return Promise.reject(error.response.data);
  }
};

export const createEmailTest = async (post: { emailType: string; toAddress: string }): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/test-emails`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createEmailTest failed'
    );
    return Promise.reject(error.response.data);
  }
};
